const Portfolio_data = [
  {
    id: 1,
    category: 'Fullstack Developer',
    totalLike: '630',
    desc: 'A startup engaged in the health sector with a business base of convenience in consulting with doctors online and offline as well as purchasing medicines',
    title: 'Nadi Health Startup',
    image: '/image/3.png',
    tech: [
      '/image/html.svg',
      '/image/css.svg',
      '/image/sass.svg',
      '/image/javascript.svg',
      '/image/reactjs.svg',
      '/image/tailwind.svg',
      '/image/nodejs.svg',
      '/image/express.svg',
      '/image/mongodb.svg',
      '/image/aws.svg',
      '/image/firebase.svg',
    ],
    tools: [
      '/image/git.svg',
      '/image/postman.svg',
      '/image/jira.svg',
      '/image/clickup.svg',
    ],
    responsible: [
      'Team Leader',
      'Assign Task to Member Tim',
      'Scrum Meeting Daily',
      'Review Code Before Merge and Deploy',
    ],
    methodology: 'Scrum Methodology',
    link: 'https://nashospital.vercel.app/#/',
  },
  {
    id: 2,
    category: 'Frontend Developer',
    totalLike: '630',
    desc: 'A startup engaged in the property. to sell or rent property in indonesia',
    title: 'Amoda Startup',
    image: '/image/amoda.png',
    tech: [
      '/image/html.svg',
      '/image/css.svg',
      '/image/sass.svg',
      '/image/javascript.svg',
      '/image/reactjs.svg',
      '/image/tailwind.svg',
      '/image/nodejs.svg',
      '/image/graphql.svg',
    ],
    tools: ['/image/git.svg', '/image/postman.svg', '/image/clickup.svg'],
    responsible: [
      'Scrum Meeting Daily',
      'Review Code Before Merge and Deploy',
      'Develop Frontend',
      'Integrate API',
    ],
    methodology: 'Scrum Methodology',
    link: 'https://property.amoda.id/',
  },
  {
    id: 3,
    category: 'Fullstack Developer',
    totalLike: '630',
    desc: 'A startup engaged in improve human value and Go interstellar with your Career Goals by building your galaxy of in-demand Green Economy skills on our gamified platform. ',
    title: 'Skilledin Startup',
    image: '/image/gs-launchpad.png',
    tech: [
      '/image/html.svg',
      '/image/css.svg',
      '/image/sass.svg',
      '/image/javascript.svg',
      '/image/reactjs.svg',
      '/image/tailwind.svg',
      '/image/golang.png',
      '/image/azure.png',
      '/image/mongodb.svg',
      '/image/clickup.svg',
    ],
    tools: ['/image/git.svg', '/image/postman.svg', '/image/clickup.svg'],
    responsible: [
      'Scrum Meeting Daily',
      'Review Code Before Merge and Deploy',
      'Develop Frontend',
      'Develop Backend',
      'Database Design',
      'Create Unit Testing',
      'Create Documentation',
      'Deploy CI/CD using Azure and github pipeline',
      'Integrate API',
    ],
    methodology: 'Scrum Methodology',
    link: 'https://skilledin.io/',
  },
  {
    id: 4,
    category: 'Fullstack Developer (Backend API)',
    totalLike: '630',
    desc: 'A startup engaged in improve human value and Go interstellar with your Career Goals by building your galaxy of in-demand Green Economy skills on our gamified platform. ',
    title: 'Skilledin Startup',
    image: '/image/api-gs-2.png',
    tech: [
      '/image/golang.png',
      '/image/azure.png',
      '/image/mongodb.svg',
      '/image/clickup.svg',
    ],
    tools: ['/image/git.svg', '/image/postman.svg', '/image/clickup.svg'],
    responsible: [
      'Scrum Meeting Daily',
      'Review Code Before Merge and Deploy',
      'Develop Backend',
      'Database Design',
      'Create Unit Testing',
      'Create Documentation',
      'Deploy CI/CD using Azure and github pipeline',
      'Integrate API',
    ],
    methodology: 'Scrum Methodology',
    link: 'https://skilledin.io/',
  },
  {
    id: 5,
    category: 'Fullstack Developer (Front End)',
    totalLike: '630',
    desc: 'A startup engaged in improve human value and Go interstellar with your Career Goals by building your galaxy of in-demand Green Economy skills on our gamified platform. ',
    title: 'Skilledin Startup',
    image: '/image/lms.png',
    tech: [
      '/image/html.svg',
      '/image/css.svg',
      '/image/sass.svg',
      '/image/javascript.svg',
      '/image/reactjs.svg',
      '/image/tailwind.svg',
      '/image/clickup.svg',
    ],
    tools: ['/image/git.svg', '/image/clickup.svg'],
    responsible: [
      'Scrum Meeting Daily',
      'Review Code Before Merge and Deploy',
      'Develop Frontend',
      'Database Design',
      'Create Unit Testing',
      'Create Documentation',
      'Deploy CI/CD using Azure and github pipeline',
      'Integrate API',
    ],
    methodology: 'Scrum Methodology',
    link: 'https://skilledin.io/',
  },
  {
    id: 6,
    category: 'Mobile UI',
    totalLike: '690',
    desc: '',
    title: 'Food Delivery App',
    image: '/image/6.png',
    tech: [
      '/image/css.svg',
      '/image/javascript.svg',
      '/image/reactnative.svg',
      '/image/redux.svg',
    ],
    tools: [
      '/image/git.svg',
      '/image/postman.svg',
      '/image/jira.svg',
      '/image/clickup.svg',
    ],
    responsible: ['handle UI'],
    methodology: 'Scrum Methodology',
  },
]
export default Portfolio_data
